
import moment from 'moment'
import Api from '@/Plugins/api'
import CashControl from '@/Models/Static/Business/CashControlType'

// MODULES
import form from './form'
import report from './report'

const modules = {
  form,
  report,
}

const state = () => ({
  /**
   * Turn confirmation visibility.
   * @type String|null
   */
  confirm: null,

  /**
   * This variable will contain the current turn in JSON format.
   * @type Object|null
   */
  turn: undefined,
})

const getters = {
  shouldCloseTurn: (state, getters, rootState, rootGetters) => {
    const turnOpened = moment.utc(state.turn?.opened, 'YYYY-MM-DD HH:mm:ss', true)
    const businessOpened = moment.utc(rootGetters['rummage/business']('openingTime'), 'HH:mm:ss')
    return moment.utc().isAfter(businessOpened) && turnOpened.isBefore(businessOpened)
  },
}

const mutations = {
  confirm (state, v) {
    state.confirm = v
  },
  turn (state, v) {
    state.turn = v
  },
}

const actions = {
  getTurn ({ getters, commit, dispatch, rootGetters }) {
    return new Promise((resolve, reject) => {
      const cashControlType = rootGetters['rummage/business']('cashControlType')
      if (cashControlType == CashControl.NONE) {
        commit('turn', null)
        resolve(null)
        return
      }
      Api('getCurrentTurn', {
        cashier_id: rootGetters['rummage/cashier']?.id,
      })
        .then(r => {
          commit('turn', r.data)
          dispatch('logTurn', 'Fetched current turn')
          if (! getters['shouldCloseTurn']) {
            resolve(r.data)
            return
          }
          if (cashControlType != CashControl.AUTO) {
            reject('mustCloseTurn')
            return
          }
          dispatch('autoTurn')
            .then(turn => resolve(turn))
            .catch(e => reject(e))
        })
        .catch(e => {
          commit('turn', null)
          dispatch('logTurn', 'Fetched current turn (no turn)')
          if (cashControlType != CashControl.AUTO) {
            reject(e.response?.status == 418 ? 'mustOpenTurn' : e)
            return
          }
          dispatch('autoTurn')
            .then(turn => resolve(turn))
            .catch(e => reject(e))
        })
    })
  },
  autoTurn ({ commit, dispatch, rootState, rootGetters }) {
    return new Promise((resolve, reject) => {
      dispatch('logTurn', 'Requesting auto turn...')
      Api('autoTurn', {
        cashier_id: rootGetters['rummage/cashier']?.id,
        tenantUser_id: rootState.user.id,
      })
        .then(r => {
          commit('turn', r.data)
          dispatch('logTurn', 'Fetched current turn')
          resolve(r.data)
        })
        .catch(e => {
          dispatch('xError', e, { root: true })
          reject(e)
        })
    })
  },
  logTurn ({ state, dispatch }, action) {
    dispatch('log', { action, model: 'Turn', model_id: state.turn?.id ?? null }, { root: true })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules
}
